import React, { Component, ReactElement } from 'react'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { WelcomeContainer } from '../Components/Organisms/WelcomeContainer/WelcomeContainer'
import { ChangeUserAgent } from '../Components/Organisms/ChangeUserAgent/Main/ChangeUserAgent'
import { BaseContexts } from '../../React/Common/BaseContexts'

@Route(RouteID.CHANGE_USER_AGENT)
export class ChangeUserAgentPage extends Component {
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.CHANGE_USER_AGENT}>
                <BaseContexts>
                    <WelcomeContainer>
                        <ChangeUserAgent />
                    </WelcomeContainer>
                </BaseContexts>
            </RouteGuard>
        )
    }
}
